import {
  Breadcrumb,
  DownloadExcel,
  ErrorAlert,
  formatNumber,
  MegaphoneIcon,
  PageHero,
  SearchToggle,
  TableRowsPerPage,
  useCallback,
  useFetchData,
  useMemo,
  useSearch,
} from "@";
import { DataTable } from "@/shared/components/tanstackTable";
import { getAffiliateDonors } from "./utils/api";
import MultiSearch from "./components/MultiSearch";
import tableColumns from "./components/tableColumns";
import { excelHeaderCellsName, searchValues } from "./utils/options";

const Index = () => {
  const links = useMemo(
    () => [{ name: "روابط المنسقين", link: "/giftProjects" }],
    [],
  );

  const { search, updateSearch } = useSearch(searchValues);

  const { data, isLoading, error, pg, fetchData, updatePg } = useFetchData({
    fun: getAffiliateDonors,
    params: [search.values],
  });

  const totalAmount = useMemo(() => {
    return data?.reduce(
      (Sum, currentValue) =>
        parseFloat(currentValue.totalAmount) + parseFloat(Sum),
      0,
    );
  }, [data]);

  const handleSearchToggle = useCallback(() => {
    updateSearch({ show: !search.show });
  }, [search.show, updateSearch]);

  return (
    <>
      <ErrorAlert reload={fetchData} show={error} />
      <Breadcrumb links={links} />

      <main className="table-card relative">
        <PageHero
          eyebrow="التسويق / التبرعات"
          title="روابط المنسقين"
          count={data?.length}
          icon={MegaphoneIcon}
          hideCount={isLoading}
          headerClassName="flex-row items-center justify-between"
        >
          <TableRowsPerPage
            pagination={pg}
            onRowsPerPageChange={(size) => updatePg({ size })}
          />

          <DownloadExcel
            pageSize={null}
            length={data?.length}
            search={search.values}
            fetch={getAffiliateDonors}
            headerCellsName={excelHeaderCellsName}
          />

          <SearchToggle toggle={handleSearchToggle} />
        </PageHero>

        {/* Aggregate total — eyebrow + bold figure, matches the design language */}
        {data?.length > 0 && (
          <div className="my-3 flex items-baseline gap-2 text-sm text-gray-500 dark:text-gray-400">
            <span className="text-[10px] font-semibold uppercase tracking-[0.2em] text-purple-700 dark:text-purple-400">
              إجمالي المختار
            </span>
            <span className="text-lg font-bold tabular-nums text-gray-900 dark:text-gray-100">
              {formatNumber(totalAmount)}
            </span>
            <span className="text-[10px] font-medium text-gray-400 dark:text-gray-500">
              ر.س
            </span>
          </div>
        )}

        <MultiSearch
          search={search}
          onSubmit={fetchData}
          dataLength={data?.length}
          updateSearch={updateSearch}
        />

        <DataTable
          data={data}
          columns={tableColumns}
          isLoading={isLoading}
          pagination={pg}
          onPageChange={(page) => updatePg({ page })}
          onPageSizeChange={(size) => updatePg({ size, page: 1 })}
        />
      </main>
    </>
  );
};

export default Index;
